import { useStaticData } from '@mc/static-data-react'

import { coursePath } from 'libs/paths'
import CTA from 'components/CTA'
import Image from 'components/LegacyImage'
import Link from 'components/Link'

const InstructorBio = () => {
  const { course } = useStaticData()

  return (
    <div className='mc-bg-gray-800 mc-corners--rounded mc-p-6 mc-mb-9'>
      <div className='d-flex align-items-center mc-mb-7'>
        <Image
          alt=''
          className='mc-corners--circle'
          height={60}
          priority
          src={course.primary1x1}
          width={60}
        />
        <div className='mc-ml-4 mc-text--left'>
          <Link
            href={coursePath(course.slug)}
            className='mc-text--link'
            passHref
          >
            {course.instructorName}
          </Link>
          <p className='mc-mt-1 mc-text-small mc-text--muted'>
            {course.headline}
          </p>
        </div>
      </div>
      <p className='mc-mb-6 mc-text-md--left mc-text--center'>
        {course.marketingCmColumn}
      </p>
      <CTA
        fullWidth
        trackProps={{
          content_type: 'product',
          location: 'lesson-page',
        }}
      />
    </div>
  )
}

export default InstructorBio
